/**
 * Direction B, the studio refresh. Built in only where the build sets VITE_STUDIO_B=true: today the beta case of
 * scripts/aws-infra/deploy-frontend.sh. Off, nothing of B loads and the app is exactly today's.
 */
export const studioBOn = (): boolean => import.meta.env.VITE_STUDIO_B === 'true';

type Boot = { bootStudioB: () => void };

/** Called once, from main.tsx. On, it loads the B tokens and marks the page <html data-ui="b">. */
export function startStudioB(load: () => Promise<Boot> = () => import('./boot')): Promise<void> | undefined {
  if (!studioBOn()) return undefined;
  return load().then((m) => m.bootStudioB());
}
